import React, { FunctionComponent } from 'react';

import { useSelector } from 'react-redux';

import {
    selectHasMembersSummarizationPermission,
    selectHasSummarizationBanRolePermission,
    setSummarizationForMembersAllowed,
} from '../../../../../../pages/call/features/permissions';
import { selectIsSummarizationAvailable } from '../../../../../../pages/call/features/summarization';
import { i18n } from '../../../../../helpers/i18n';
import { selectIsCalendarSummarizationFeatureEnabled } from '../../../../flags/selectors';
import { useOnPermissionChange } from '../../../hooks/use-on-permission-change';
import { SettingsTumbler } from './settings-tumbler';

export const SummarizationTumbler: FunctionComponent = () => {
    const calendarSummarizationFeatureEnabled = useSelector(selectIsCalendarSummarizationFeatureEnabled);
    const isSummarizationAvailable = useSelector(selectIsSummarizationAvailable);
    const hasBanPermission = useSelector(selectHasSummarizationBanRolePermission);
    const hasMembersPermission = useSelector(selectHasMembersSummarizationPermission);

    const onChange = useOnPermissionChange(setSummarizationForMembersAllowed, 'summarization_manage_for_participants');

    if (!isSummarizationAvailable || !hasBanPermission) {
        return null;
    }

    return (
        <SettingsTumbler
            testId="summarization-tumbler"
            label={i18n(
                'settings-v2',
                calendarSummarizationFeatureEnabled
                    ? 'role-permission-summarization'
                    : 'permission-ban-summarization-v2'
            )}
            checked={hasMembersPermission}
            onChange={onChange}
        />
    );
};
